export const GET_MONETIZATION_REQUEST = "GET_MONETIZATION_REQUEST";
export const ACCEPT_MONETIZATION_REQUEST = "ACCEPT_MONETIZATION_REQUEST";
